import { createService } from './baseRequest.js'
import { message } from 'ant-design-vue'
const options = {
  response: response => {
    const res = response.data
    const headers = response.headers
    if (res.code === 200) {
      return res.data || res.result
    } else if (res.code === 403) {
      // 未授权页面跳转
      window.location.href = '/403'
    } else if (headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8') {
      return res
    } else if (res.code === 401) {
      location.href = `${process.env.VUE_APP_PASSPORT_URL}/api/op/auth/login?redirectUrl=${encodeURIComponent(location.href)}`
    } else {
      message.error(res.message || '服务器异常')
      return Promise.reject(res.message)
    }
  }
}
const service = createService(
  options
)

let requestFn = service
if (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
  const mock = require('@di/netease-hy-mock').default
  requestFn = mock({ service })
}

export default requestFn
